import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/monitoring'
)({
  staticData: { pageHeader: { title: 'Monitoring', pad: false } },
})
